var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { config as appConfig } from 'lib-shared-backend-config';
import { addInterceptors } from 'utils/apis/axios/interceptors/addInterceptors';
import { authManager } from 'utils/auth/authManager';
/** The axios instance to use. */
const axiosInstance = axios.create();
addInterceptors(axiosInstance);
/** Represents shorthand notations for the base path. */
export var ApiBasePath;
(function (ApiBasePath) {
    ApiBasePath[ApiBasePath["Rest"] = 0] = "Rest";
    ApiBasePath[ApiBasePath["Files"] = 1] = "Files";
})(ApiBasePath || (ApiBasePath = {}));
/** Represents the error status codes. */
export var ApiErrorStatusCode;
(function (ApiErrorStatusCode) {
    ApiErrorStatusCode[ApiErrorStatusCode["BadRequest"] = 400] = "BadRequest";
    ApiErrorStatusCode[ApiErrorStatusCode["Unauthorized"] = 401] = "Unauthorized";
    ApiErrorStatusCode[ApiErrorStatusCode["Forbidden"] = 403] = "Forbidden";
    ApiErrorStatusCode[ApiErrorStatusCode["NotFound"] = 404] = "NotFound";
    ApiErrorStatusCode[ApiErrorStatusCode["Conflict"] = 409] = "Conflict";
    ApiErrorStatusCode[ApiErrorStatusCode["InternalServerError"] = 500] = "InternalServerError";
    ApiErrorStatusCode[ApiErrorStatusCode["BadGateway"] = 502] = "BadGateway";
    ApiErrorStatusCode[ApiErrorStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
})(ApiErrorStatusCode || (ApiErrorStatusCode = {}));
/** Mappings from shorthand base url names to urls. */
const API_BASE_URL = {
    [ApiBasePath.Rest]: appConfig.url.rest,
    [ApiBasePath.Files]: appConfig.url.files,
};
/** Mapping from consumer friendly header names to what ends in the http headers. */
const CONTENT_TYPE = {
    contentType: 'Content-Type',
    authorization: 'Authorization',
};
/**
 * Creates an axios config from the request.
 *
 * @param request The request.
 */
function createAxiosConfig(request) {
    return __awaiter(this, void 0, void 0, function* () {
        const authData = yield authManager.getAuth();
        const token = authData === null || authData === void 0 ? void 0 : authData.access_token;
        const tokenBase64 = token ? btoa(`token:${token}`) : '';
        const defaultHeaders = {
            contentType: 'application/json',
            authorization: `Basic ${tokenBase64}`,
        };
        return Object.assign(Object.assign(Object.assign(Object.assign({ url: request.path, method: request.method || 'GET', baseURL: request.basePath != null
                ? typeof request.basePath === 'string'
                    ? request.basePath
                    : API_BASE_URL[request.basePath]
                : API_BASE_URL[ApiBasePath.Rest], headers: Object.entries(Object.assign(Object.assign({}, defaultHeaders), (request.headers || {}))).reduce((headers, [key, value]) => value == null
                ? headers
                : ((headers[CONTENT_TYPE[key]] = value), headers), {}) }, (request.responseType ? { responseType: request.responseType } : {})), (request.params ? { params: request.params } : {})), (request.data ? { data: request.data } : {})), { validateStatus: (status) => {
                const ignoreErrorCodes = request.ignoreErrorCodes || [];
                if (ignoreErrorCodes.includes(status))
                    return true;
                return status >= 200 && status < 300; // default
            } });
    });
}
export function ajaxSend(request, returnFullResponse = false) {
    return __awaiter(this, void 0, void 0, function* () {
        const config = yield createAxiosConfig(request);
        try {
            const response = yield axiosInstance.request(config);
            return returnFullResponse ? response : response.data;
        }
        catch (error) {
            const exception = error;
            return Promise.reject(exception);
        }
    });
}
